// External libraries
import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import { appStore } from '@/store';

// Internal modules
import { ENTERPRISE_CONTENT_KEYS, getTermsMap } from './constants';
import { Link } from '@/components/Common';
import { logBillingTermLinkClickToFpti } from './fpti';
import {
  buildTermsUrl,
  getContent,
  getLocale,
  getNestedContentKeys,
} from '@/lib';

export const getTermsLinks = (termsKey: string): Record<string, ReactNode> => {
  const TERMS_MAP = getTermsMap(getLocale());

  const nestedKeys = getNestedContentKeys(termsKey);

  const allowedKeys = Object.keys(TERMS_MAP);

  if (!Array.isArray(nestedKeys)) {
    return {};
  }
  /* 
    TS gives us a hard time here due to a over complicated
    dynamic integration. We should refactor this code in the future.
  */
  return nestedKeys
    .filter(key => allowedKeys.includes(key))
    .reduce((termsObj, link) => {
      //@ts-expect-error
      termsObj[link] =
        //@ts-expect-error
        link === 'brTag' ? <br /> : <TermLink {...TERMS_MAP[link]} />;
      return termsObj;
    }, {});
};

export const TermLink = ({
  contentKey,
  getDynamicPath,
  path,
}: {
  contentKey: string;
  getDynamicPath: () => string;
  path: string;
}): ReactElement => {
  const { consentCode } = appStore.getState().api;

  const isEnterpriseLink =
    consentCode && ENTERPRISE_CONTENT_KEYS.includes(contentKey);

  const termsKey = `${
    isEnterpriseLink ? 'enterpriseAgreement' : 'billingAgreement'
  }.${contentKey}`;
  const content = getContent(termsKey);

  let href;
  if (path === 'backupPayment') {
    href = buildTermsUrl({ useFunction: 'backupPayment' });
  }
  if (isEnterpriseLink) {
    href = path;
  }
  return (
    <Link
      onClick={() => logBillingTermLinkClickToFpti(contentKey)}
      href={!href ? buildTermsUrl({ getDynamicPath, path }) : href}
      text={content}
    />
  );
};
